import { useState } from 'react';

import { Modal as ModalAntD, PageHeader, Result } from 'antd';
import moment from 'moment';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { T } from 'react-translator-component';

import * as S from './styled';

import { createVouchers } from '../../../hooks/vouchers';
import {
  setUsersVoucherList,
  setVoucherFormValues,
} from '../../../redux/actions/voucher';
import { FORM_VALUES_INITIAL_STATE } from '../../../redux/reducers/voucher';
import VoucherIcon from '../../atoms/icons/VoucherIcon';
import { COLORS } from '../../molecules/ConnectorColored/helpers';
import VoucherForm, {
  VoucherExpireType,
} from '../../organisms/VoucherForm/VoucherForm';
import { VoucherUserSelectedPksWithVoucherStatus } from '../../organisms/VoucherSelectUsersList/VoucherSelectUsersList';

const Modal: any = ModalAntD;

const user = JSON.parse(localStorage.getItem('auth-user') as any);

const rawMaskMoney = (value: string) => {
  const onlyDigits = value
    .split('')
    .filter((s) => /\d/.test(s))
    .join('')
    .padStart(3, '0');

  const digitsFloat = onlyDigits.slice(0, -2) + '.' + onlyDigits.slice(-2);

  return digitsFloat;
};

const VoucherCreatePage = ({ chargePointsList }: any) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userPks = useSelector((state: any) => state?.voucher?.userPks);
  const formValues = useSelector((state: any) => state?.voucher?.formValues);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const clearVoucherTemporaryValues = () => {
    dispatch(setUsersVoucherList([]));

    dispatch(setVoucherFormValues(FORM_VALUES_INITIAL_STATE));
  };

  const handleCreateVouchers = async (values: any) => {
    setLoading(true);

    const tryCreateVouchers = await createVouchers({
      code: values.code,
      description: values.description,
      kind: values.kind,
      kind_value:
        values.kind === 'MONEY_RECHARGE'
          ? rawMaskMoney(values.kind_value)
          : Number(values.kind_value),
      title: values.title,
      units: Number(values.units),
      start: moment(values.start).utc().format('YYYY-MM-DD HH:mm:ss'),
      expire: moment(values.expire).utc().format('YYYY-MM-DD HH:mm:ss'),
      charge_box_pks: values.charge_box_pks || null,
      tenant_pk: user.tenant_pk,
      active: values.active,
      user_pks:
        userPks.map(
          (user: VoucherUserSelectedPksWithVoucherStatus) =>
            user?.user_pk || user,
        ) || null,
      uses_per_user: values.uses_per_user || 1,
      expire_type: values.expire_type || VoucherExpireType.ExpirationDate,
    });

    if (tryCreateVouchers.type === 'error') {
      setError(true);
    } else if (tryCreateVouchers.type === 'success') {
      setSuccess(true);
    }

    setLoading(false);
  };

  const handleSaveChanges = (values) => {
    dispatch(setVoucherFormValues(values));
  };

  const handleGoBack = () => {
    clearVoucherTemporaryValues();

    history.goBack();
  };

  return (
    <>
      <S.Wrapper>
        <PageHeader
          onBack={handleGoBack}
          title={
            <>
              <VoucherIcon
                style={{ position: 'relative', top: 3, marginRight: 16 }}
                fill={COLORS.black}
                height={20}
                width={20}
              />

              {T('Creating voucher')}
            </>
          }
        />

        <S.Blank>
          <VoucherForm
            initialValues={{
              ...formValues,
            }}
            onSaveChanges={handleSaveChanges}
            loading={loading}
            isActivation={false}
            chargePointsList={chargePointsList}
            onSubmit={handleCreateVouchers}
          />
        </S.Blank>
      </S.Wrapper>

      <Modal
        visible={success}
        onOk={() => {}}
        onCancel={() => {}}
        closable={false}
        footer={null}
      >
        <Result
          status='success'
          title='Voucher cadastrado com sucesso!'
          extra={[
            <S.Button
              type='primary'
              key='console'
              size='large'
              onClick={() => {
                clearVoucherTemporaryValues();

                history.push('/vouchers');
              }}
            >
              Ver listagem atualizada
            </S.Button>,
          ]}
        />
      </Modal>
      <Modal visible={error} closable={false} footer={null}>
        <Result
          status='error'
          title='Não foi possível criar o Voucher!'
          extra={[
            <S.Button
              key='default'
              size='large'
              onClick={() => {
                clearVoucherTemporaryValues();

                history.push('/vouchers');
              }}
            >
              Ver listagem
            </S.Button>,
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={() => setError(false)}
            >
              Tentar novamente
            </S.Button>,
          ]}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  chargePointsList: state.chargePoints.chargePoints.chargePointList,
});

export default connect(mapStateToProps)(VoucherCreatePage);
